module.exports = __webpack_public_path__ + "static/media/icon-download.cdc1fb8c.svg";